var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('show-model',{attrs:{"text":_vm.data}}),_c('div',{ref:"chartdiv",staticClass:"chartdiv",style:({height: _vm.height+'px'})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }